module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1289.2832b3a4.png";